import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import CustomButton from "../../../../Components/Button/CustomButton";
import CustomInput from "../../../../Components/input/CustomInput";
import gallery from "../../../../Utils/Images/Gallery Send.png";
import { Link, useNavigate } from "react-router-dom";
import { handleAddWorkout } from "../../../../APIs/Function/Workout/WorkoutPlans/AddWorkout";

const AddWorkoutPlans = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState("");
  const [previewVideo, setPreviewVideo] = useState("");

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: null,
    video: null,
  });
  const initialFormData = {
    title: "",
    description: "",
    image: null,
    video: null,
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleImageChange = (event) => {
    const image = event.target.files[0];
    if (image) {
      setFormData({
        ...formData,
        image: image,
      });

      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(image);
    } else {
      setFormData({
        ...formData,
        image: null,
      });
      setPreviewImage("");
    }
  };

  const handleVideoChange = (event) => {
    const video = event.target.files[0];
    if (video) {
      setFormData({
        ...formData,
        video: video,
      });

      const reader = new FileReader();
      reader.onload = () => {
        setPreviewVideo(reader.result);
      };
      reader.readAsDataURL(video);
    } else {
      
      setFormData({
        ...formData,
        video: null, 
      });
      setPreviewVideo(""); 
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      formData.title.trim() !== "" &&
      formData.description.trim() !== "" &&
      formData.image &&
      formData.video
    ) {
      try {
        setLoading(true);
        let res = await handleAddWorkout(formData);
        if (res.s) {
          setLoading(false);
          alert("Data Added Succesfully");
          navigate("/workoutplans");
        }
        setFormData(initialFormData);
      } catch (error) {
        console.log(error);
      }
    } else {
      alert("Please Fill All Fields");
    }
  };

  return (
    <>
      {/* header */}
      <Box
        sx={{
          bgcolor: "#31AEF4",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: { xs: "50px", md: "70px", lg: "70px" },
          p: "10px",
          boxSizing: "border-box",
        }}
      >
        <Link to={"/workoutplans"}>
          <Box
            sx={{
              height: { xs: "50px", md: "60px", lg: "60px" },
              display: "flex",
              alignItems: "center",
            }}
          >
            <img height={"100%"} src={backbluebtn} alt="back" />
          </Box>
        </Link>
        <Box>
          <Typography
            sx={{
              fontFamily: "Open Sans",
              fontSize: { md: "30px", sm: "20px" },
              fontWeight: 600,
              lineHeight: "36px",
              color: "#FFFFFF",
            }}
          >
            Add Details
          </Typography>
        </Box>
        <Box>
          <CustomButton
            onClick={handleSubmit}
            sx={{
              width: { xs: "40px", md: "50px", lg: "80px" },
              height: { xs: "10px", md: "50px", lg: "50px " },
            }}
          >
            {loading ? <CircularProgress></CircularProgress> : "Save"}
          </CustomButton>
        </Box>
      </Box>
      {/* form */}
      <Container maxWidth="sm" sx={{ mt: "30px" }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomInput
                label="Title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                label="Description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                fullWidth
                multiline
                rows={4}
                required
              />
            </Grid>

            <Grid item xs={6}>
              <label htmlFor="file-image-input">
                <Box
                  sx={{
                    width: "100%",
                    height: "200px",
                    bgcolor: "#F4F4F4",
                    p: "20px",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center ",
                    justifyContent: "center",
                    flexDirection: "column",
                    cursor: "pointer",
                  }}
                >
                  <Box>
                    <img
                      style={{ width: "100%", maxHeight: "180px" }}
                      src={previewImage ? previewImage : gallery}
                      alt="Preview"
                    />
                  </Box>
                  {!previewImage ? (
                    <Typography sx={{}}>Upload Banner Image</Typography>
                  ) : (
                    ""
                  )}
                </Box>
              </label>
              <input
                accept="image/*"
                type="file"
                id="file-image-input"
                onChange={handleImageChange}
                style={{ display: "none" }}
              />
            </Grid>
            <Grid item xs={6}>
              <label htmlFor="file-video-input">
                <Box
                  sx={{
                    width: "100%",
                    height: "200px",
                    bgcolor: "#F4F4F4",
                    p: "20px",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center ",
                    justifyContent: "center",
                    flexDirection: "column",
                    cursor: "pointer",
                  }}
                >
                  <Box>
                    {previewVideo ? (
                      <video
                        controls
                        style={{ width: "100%", maxHeight: "200px" }}
                      >
                        <source src={previewVideo} type="video/mp4" />
                      </video>
                    ) : (
                      <img src={gallery} alt="" />
                    )}
                  </Box>
                  {!previewVideo ? (
                    <Typography sx={{}}>Upload Video</Typography>
                  ) : (
                    ""
                  )}
                </Box>
              </label>
              <input
                accept="video/*"
                type="file"
                id="file-video-input"
                onChange={handleVideoChange}
                style={{ display: "none" }}
              />
            </Grid>
          </Grid>
        </form>
      </Container>
    </>
  );
};

export default AddWorkoutPlans;
